var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SideCircles',{staticClass:"banner-design-elements",staticStyle:{"right":"80px","top":"-20px","opacity":"0.4"},attrs:{"width":"300px","fill":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }